import Vue from 'vue'
import Router from 'vue-router'
import ChooseCompany from '../components/ChooseCompany/ChooseCompany.vue'
import Password from '../components/Password/Password.vue'
import PunchTimelog from '../components/PunchTimelog/PunchTimelog.vue'
import Permission from '../components/Permission/Permission.vue'
import Record from '../components/RecordVoice/Record.vue'
import Register from '../components/Register/Register.vue'
import { API } from '../services'

import { SolarSSOLogin, SAMLLoginUrl, startRefreshTokenWorker } from '../components/Register/cognito'
import store from '../store/store'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: { name: 'register' , params: {type: 'code'}},
      meta: { goToPasswordIfHasBrowserRecord: true }
    },
    {
      path: '/chooseCompany',
      name: 'chooseCompany',
      component: ChooseCompany,
      meta: { goToPasswordIfHasBrowserRecord: true }
    },
    {
      path: '/password',
      name: 'password',
      component: Password,
      meta: { requiresBrowserId: true, requiresBrowserActive: true }
    },
    {
      path: '/punch-timelog',
      name: 'punchTimelog',
      component: PunchTimelog,
      meta: { requiresBrowserId: true, requiresBrowserActive: true }
    },
    {
      path: '/no-permission',
      name: 'permission',
      component: Permission,
      meta: {requiresBrowserId: true }
    },
    {
      path: '/clear',
      name: 'clear'
    },
    {
      path: '/logout',
      name: 'logout',
      meta: { logout: true }
    },
    {
      path: '/record',
      name: 'record',
      component: Record
    },
    {
      path: '/register/:type/',
      name: 'register',
      props: true,
      component: Register,
      meta: { goToPasswordIfHasBrowserRecord: true }
    }
  ]
})

router.beforeEach(async (...rota) => {
  const [to, from, next] = rota
  const { accessData } = store.state

  const rotasDeLoginComSSO = {
    BV: window.location.href.includes('?user_pool_id='),
    SOLAR: window.location.href.includes('/login?token=')
  }

  const utilizaLoginComSSO = [...Object.values(rotasDeLoginComSSO)].some(Boolean) && from.name == null

  if (utilizaLoginComSSO) {
    // DO NOT DISPATCH 'logout' INSIDE THIS IF
    if (rotasDeLoginComSSO.SOLAR) {
      await SolarSSOLogin(...rota)
      return
    } else if (rotasDeLoginComSSO.BV) {
      await SAMLLoginUrl()
      return
    }
  }

  // SAML STEPS

  // check was redirected from saml
  if (window.location.href.includes('?user_pool_id=') && from.name == null) {
    await SAMLLoginUrl()
    return
  }

  if (accessData.cognitoInfo && accessData.cognitoInfo.isSamlLogin && !['punchTimelog', 'logout', 'clear'].includes(to.name)) {
    // already signed in with SAML
    try {
      startRefreshTokenWorker()
      await store.dispatch('register/registerWithSSO')
      return
    } catch (e) {
      await store.dispatch('logout')
      return
    }
  }

  if (to.name === 'logout') {
    store.dispatch('logout')
  }

  if (to.name === 'clear') {
    store.dispatch('clear')
  }

  // load visual anyway, the action knows if really need, so, maybe the request are not made
  await store.dispatch('getVisual', {})

  // 1º validate view that need browserId
  if (to.meta.requiresBrowserId && !accessData.browserRecord) {
    next('/register/code')
    return
  }

  if (to.meta.requiresBrowserActive && !accessData.browserRecord.active) {
    next('/no-permission')
    return
  }

  if (to.meta.requiresBrowserId && store.state.accessData.browserRecord) {
    store.dispatch('getVisual', {reloadIfIsDefault: true})
  }

  if(to.meta.goToPasswordIfHasBrowserRecord && store.state.accessData.browserRecord) {
    store.dispatch('getVisual', {reloadIfIsDefault: true})
    next('/password')
  }

  next()
})

export default router
